// 商品库管理-商品基础库-别名维护页面
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Form,
  Button,
  Modal,
  message,
  Input,
  TreeSelect,
  Select,
  Divider,
  Table,
} from 'antd-v5';

import PageHeaderLayout from '../../../component/page-header-layout/index';
import EditPng from '../../../common/images/icon/edit.png';
import '../commodity-base/index.less';

import SpuFormModal from '../commodity-base/spuFormModal';
import {
  editSpuRequest,
  getSpuCategoryTreeListRequest,
  pageSpuRelationRequest,
} from '../../../state/request/cxmProductSpuCategory';

const { Column } = Table;

class AddGoodsPage extends PureComponent {
  constructor(props) {
    super(props);
    const { rows } = this.props.history.location.state;
    this.state = {
      loading: false,
      defaultCurrent: 1,
      dataSource: {},
      rows,
      visible: false,
      treeData: [],
      searchValues: {},
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.getPageSpuRelation();
    // this.getSpuCategoryList();
  }

  // getSpuCategoryList = async () => {
  //   const res = await getSpuCategoryTreeListRequest();
  //   if (res?.code === 200) {
  //     this.setState({ treeData: res.data });
  //   }
  // };
  getPageSpuRelation = async () => {
    const { rows, defaultCurrent, searchValues } = this.state;
    const params = {
      ...searchValues,
      spuId: rows.id,
      pageNo: defaultCurrent,
      pageSize: 10,
    };
    const res = await pageSpuRelationRequest(params);
    if (res?.code === 200) {
      this.setState({ dataSource: res.data });
    }
  };
  handleSumbit = (values) => {
    this.setState(
      {
        defaultCurrent: 1,
        searchValues: values,
      },
      () => {
        this.getPageSpuRelation();
      },
    );
  };
  handleReset = () => {
    this.formRef.current.resetFields();
    this.setState(
      {
        defaultCurrent: 1,
        searchValues: {},
      },
      () => {
        this.getPageSpuRelation();
      },
    );
  };

  // convertToTreeData = (data, disabled = false) => {
  //   if (!Array.isArray(data)) return [];
  //   return data.map((item) => ({
  //     title: item.name,
  //     value: item.id,
  //     level: item.level,
  //     disabled: disabled ? item.level === 1 || item.level === 2 : false,
  //     children: this.convertToTreeData(item.childNodeList, disabled),
  //   }));
  // };

  isUndefied = (value) => {
    return value || null;
  };
  gotoBack = () => {
    const { searchValues, defaultCurrent } = this.props.history.location.state;
    this.props.history.push({
      pathname: '/commodityManage2.0/commodityBase',
      state: { searchValues, defaultCurrent },
    });
  };
  pageSwitch = (obj) => {
    this.setState(
      {
        defaultCurrent: obj.current,
      },
      () => {
        this.getCommodityBaseList();
      },
    );
  };
  // showGoodsModal = (visible) => {
  //   this.setState({
  //     visible,
  //   });
  // };
  // editHandleSubmit = async (values) => {
  //   const { rows } = this.state;
  //   const params = {
  //     ...values,
  //   };
  //   if (rows.id) {
  //     params.id = rows.id;
  //   }
  //   const res = await editSpuRequest(params);
  //   if (res.code === 200) {
  //     message.success('修改成功');
  //     this.setState({
  //       visible: false,
  //       rows: params,
  //     });
  //   }
  // };

  render() {
    const { dataSource, defaultCurrent, loading, treeData, visible, rows } = this.state;
    const { pageList = [], totalSize } = dataSource;
    const pagination = {
      pageSize: 10,
      total: totalSize,
      current: defaultCurrent,
      showSizeChanger: false,
    };
    return (
      <div className='commodity-index'>
        <PageHeaderLayout>
          <Row>
            <Col span={8} style={{ fontSize: 18, fontWeight: 'bold' }}>
              基库货品：{rows.name}
              {/* <img src={EditPng} alt='' style={{ width: 20, marginLeft: 8 }} /> */}
            </Col>
            <Col span={8} style={{ fontSize: 18, fontWeight: 'bold' }}>
              基库货品分类：{rows.categoryName}
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Button type='primary' onClick={this.gotoBack}>
                返回货品库
              </Button>
            </Col>
          </Row>
          <Form
            ref={this.formRef}
            onFinish={this.handleSumbit}
            layout='inline'
            style={{ marginBottom: 24, marginTop: 12 }}
          >
            <Form.Item label='商行业务ID' name='businessCode'>
              <Input style={{ width: 150 }} placeholder='请输入商行业务ID' allowClear />
            </Form.Item>
            <Form.Item>
              <Button type='primary' htmlType='submit'>
                查询
              </Button>
              <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
                重置
              </Button>
            </Form.Item>
          </Form>
          <Table
            rowKey={(_, index) => index}
            dataSource={pageList}
            pagination={pagination}
            bordered
            loading={loading}
            onChange={this.pageSwitch.bind(this)}
          >
            <Column title='商行货品' dataIndex='productName' key='productName' />
            <Column title='近七天价格区间' dataIndex='price' key='price' />
            <Column
              title='包装类型'
              dataIndex='packKind'
              key='packKind'
              render={(_, record) => {
                const packKind = record.packKind;
                //1：定装 2：非定装 3：散装  5: 郊菜  7: 拆包
                if (1 === packKind) {
                  return '定装';
                } else if (2 === packKind) {
                  return '非定装';
                } else if (3 === packKind) {
                  return '散装';
                } else if (5 === packKind) {
                  return '郊菜';
                } else if (7 === packKind) {
                  return '拆包';
                }
                return packKind;
              }}
            />
            <Column title='分类名称' dataIndex='categoryName' key='categoryName' />
            <Column
              title='商行业务ID'
              dataIndex='businessCode'
              key='businessCode'
              width={160}
              render={(_, { businessCode, stallId }) => {
                return (
                  <div>
                    <a
                      href='/'
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.history.push({
                          pathname: '/booth/stallManager/stallManagementDetail',
                          state: { stallId, from: 'GO_BACK' },
                        });
                      }}
                    >
                      {businessCode || '- -'}
                    </a>
                  </div>
                );
              }}
            />
            <Column title='商行名称' dataIndex='stallName' key='stallName' />
          </Table>
          {/* <SpuFormModal
            title='编辑基库货品（SPU）'
            treeData={this.convertToTreeData(treeData, true)}
            visible={visible}
            onCancel={() => this.showGoodsModal(false)}
            onSave={this.editHandleSubmit}
            rows={rows}
          /> */}
        </PageHeaderLayout>
      </div>
    );
  }
}
export default AddGoodsPage;
